<template>
  <Component :is="pageComponent"/>
</template>

<script>
import LayoutPrimary from "@/mixins/LayoutPrimary";
import SitemapDesktop from "~/components/Page/Sitemap/SitemapDesktop.vue";
import SitemapMobile from "~/components/Page/Sitemap/SitemapMobile.vue";

export default {
  name: 'SitemapPage',
  mixins: [LayoutPrimary],
  head() {
    return {
      title: 'Карта сайта МТС Линк',
            meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Для быстрой и удобной навигации по сайту рекомендуем воспользоваться графической картой, с ссылками на основные разделы и подразделы сайта.',
        },
      ],
      bodyAttrs: {
        class: 'grey-body',
      },
    };
  },
  computed: {
    pageComponent: (ctx) => ctx.$device.isMobile ? SitemapMobile : SitemapDesktop,
  }
};
</script>
